import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import Basic_1695149695, { _demoInfo as Basic_1695149695_demoInfo } from "../../../../../packages/console-combo-chart/demo/Basic.tsx?loadDemo";
import YAxisColor_1695149695, { _demoInfo as YAxisColor_1695149695_demoInfo } from "../../../../../packages/console-combo-chart/demo/YAxisColor.tsx?loadDemo";
import SingleYAxis_1695149695, { _demoInfo as SingleYAxis_1695149695_demoInfo } from "../../../../../packages/console-combo-chart/demo/SingleYAxis.tsx?loadDemo";
import Smooth_1695149695, { _demoInfo as Smooth_1695149695_demoInfo } from "../../../../../packages/console-combo-chart/demo/Smooth.tsx?loadDemo";
import Stack_1695149695, { _demoInfo as Stack_1695149695_demoInfo } from "../../../../../packages/console-combo-chart/demo/Stack.tsx?loadDemo";
import Color_1695149695, { _demoInfo as Color_1695149695_demoInfo } from "../../../../../packages/console-combo-chart/demo/Color.tsx?loadDemo";
import React from 'react';
export default {
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  Basic_1695149695,
  Basic_1695149695_demoInfo,
  YAxisColor_1695149695,
  YAxisColor_1695149695_demoInfo,
  SingleYAxis_1695149695,
  SingleYAxis_1695149695_demoInfo,
  Smooth_1695149695,
  Smooth_1695149695_demoInfo,
  Stack_1695149695,
  Stack_1695149695_demoInfo,
  Color_1695149695,
  Color_1695149695_demoInfo,
  React
};